import React from 'react';
import HfAppShellLayout from '@root/app/shared/components/_migrated/app-shell/HfAppShellLayout';

const ProtectedLayout: React.FC = () => <HfAppShellLayout />;

export default ProtectedLayout;
